export enum MiscActivityCategory {
    General,
    Drafting,
    CustomerNote,
    SeekAdvice,
};